import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ICreateAccount } from '../../../../shared/account/create-account.helper';

@Component({
  selector: 'app-step4',
  templateUrl: './step4.component.html',
})
export class Step4Component {
  @Output()
  public finishClick = new EventEmitter<void>();

  @Input()
  public createdAccount: ICreateAccount;

  constructor() {}
}
